module.exports = __webpack_public_path__ + "img/Souni_Logo.e00113db.svg";